import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  MenuItem,
  Switch,
  Backdrop,
  CircularProgress,
  Button,
  Divider,
  Stack,
  Chip
} from '@material-ui/core';
import { TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import Page from '../components/Page';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useRecoilState } from 'recoil';
import { snackbarAtom } from 'src/atoms/snackbar';
import axios from 'axios';
import * as dayjs from 'dayjs';

const NewEmployee = () => {
  /* eslint-disable no-unused-vars */
  const [snackbar, setSnackbar] = useRecoilState(snackbarAtom);
  const navigate = useNavigate();
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('lg'));
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [employeeId, setEmployeeId] = useState('');
  const [active, setActive] = useState(true);

  const [totalBalance, setTotalBalance] = useState(0);
  const [glassesBalance, setGlassesBalance] = useState(0);
  const [dentalBalance, setDentalBalance] = useState(0);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  const [role, setRole] = useState('');
  const [office, setOffice] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');

  const [birthdate, setBirthdate] = useState(dayjs(new Date()));
  const [startCeiling, setStartCeiling] = useState(dayjs(new Date()));
  const [endCeiling, setEndCeiling] = useState(dayjs(new Date()));
  const [startBalance, setStartBalance] = useState(dayjs(new Date()));
  const [endBalance, setEndBalance] = useState(dayjs(new Date()));

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const handleAddBeneficiaries = () => {
    setBeneficiaries((x) => {
      return [
        ...x,
        {
          id: uuidv4(),
          dentalBalance: 0,
          glassesBalance: 0,
          name: '',
          gender: '',
          relationship: '',
          startBalance: startBalance,
          endBalance: endBalance,
          birthdate: dayjs(new Date())
        }
      ];
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setOpenBackdrop(true);
    const body = {
      name,
      email,
      gender,
      role,
      active,
      office,
      birthdate,
      marital_status: maritalStatus,
      total_balance: totalBalance,
      ceiling_limit_start_date: startCeiling,
      ceiling_limit_end_date: endCeiling,
      total_glasses_balance: glassesBalance,
      total_dental_balance: dentalBalance,
      balance_start_date: startBalance,
      balance_end_date: endBalance,
      employeeId: employeeId
    };
    const beneficiariesBodies = beneficiaries.map((x) => {
      return {
        name: x.name,
        birthdate: x.birthdate,
        relationship: x.relationship,
        gender: x.gender,
        total_dental_balance: x.dentalBalance,
        total_glasses_balance: x.glassesBalance,
        start_date: x.startBalance,
        end_date: x.endBalance,
        last_edit: dayjs(new Date())
      };
    });

    try {
      const { data, status } = await axios({
        url: '/employees',
        credentials: 'include',
        method: 'POST',
        data: body
      });
      if (status !== 201) {
        throw new Error("Couldn't make employee");
      }
      const partyId = data.id;
      beneficiariesBodies.forEach(async (ben) => {
        const { status } = await axios({
          url: `/employees/${partyId}/beneficiaries`,
          method: 'POST',
          data: ben
        });
        if (status !== 201) {
          throw new Error("Couldn't make beneficiary");
        }
      });
      navigate('../');
    } catch (err) {
      setSnackbar({ severity: 'error', open: true, message: err.message });
      console.log(err);
    } finally {
      setOpenBackdrop(false);
    }
  };
  return (
    <Page title="Create Employee | Incorta Care">
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form
        onSubmit={handleSubmit}
        style={{
          paddingInline: match ? '16px' : '0',
          maxWidth: '70vw',
          margin: '0 auto'
        }}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          fullWidth
          mb={4}
        >
          <Typography variant="h4">Create Employee</Typography>
          <FormControlLabel
            style={{
              position: 'relative'
              // left: mobile ? '-16px' : '0'
            }}
            control={
              <Switch
                checked={active}
                onChange={async (e) => {
                  setActive(e.target.checked);
                }}
              />
            }
            label={active ? 'Active' : 'Disabled'}
          />
        </Stack>
        <Stack direction="column" fullWidth>
          <Grid container alignItems="center" spacing={2}>
            {/* User specific data */}
            <Grid item md={3} xs={12}>
              <TextField
                label="Name"
                required
                variant="outlined"
                type="text"
                value={name}
                fullWidth
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            <Grid item md={4} xs={12} my={{ xs: 2, md: 0 }}>
              <TextField
                label="Email"
                required
                variant="outlined"
                value={email}
                fullWidth
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                type="email"
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{ textField: { variant: 'outlined' } }}
                  label="Birthdate"
                  value={birthdate}
                  onChange={(newValue) => {
                    setBirthdate(dayjs(newValue));
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl required fullWidth>
                <InputLabel id="gender-select-label">Gender</InputLabel>
                <Select
                  required
                  labelId="gender-select-label"
                  label="Gender"
                  id="gender-select"
                  value={gender}
                  variant="outlined"
                  fullWidth
                  style={{
                    borderRadius: '5px'
                  }}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <MenuItem value={'MALE'}>Male</MenuItem>
                  <MenuItem value={'FEMALE'}>Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container my={2} spacing={2}>
            <Grid item md={3} xs={12}>
              <TextField
                label="Balance (USD)"
                variant="outlined"
                required
                type="number"
                value={totalBalance}
                onChange={(e) => {
                  setTotalBalance(Number(e.target.value));
                }}
                fullWidth
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                label="Employee ID"
                variant="outlined"
                required
                type="text"
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(e.target.value);
                }}
                fullWidth
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="marital-status-label">Marital Status</InputLabel>
                <Select
                  labelId="marital-status-label"
                  id="marital-status"
                  label="Marital Status"
                  sx={{
                    borderRadius: '5px'
                  }}
                  value={maritalStatus}
                  variant="outlined"
                  onChange={(e) => setMaritalStatus(e.target.value)}
                >
                  <MenuItem value={'SINGLE'}>Single</MenuItem>
                  <MenuItem value={'MARRIED'}>Married</MenuItem>
                  <MenuItem value={'DIVORCED'}>Divorced</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="role-select-label">Role</InputLabel>
                <Select
                  labelId="role-select-label"
                  id="role-select"
                  value={role}
                  label="Role"
                  sx={{
                    borderRadius: '5px'
                  }}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <MenuItem value={'EMPLOYEE'}>Employee</MenuItem>
                  <MenuItem value={'DOCTOR'}>Doctor</MenuItem>
                  <MenuItem value={'FINANCE'}>Finance</MenuItem>
                  <MenuItem value={'ADMIN'}>Admin</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="office-select-label">Office </InputLabel>
                <Select
                  labelId="office-select-label"
                  id="office-select"
                  label="Office"
                  value={office}
                  sx={{
                    borderRadius: '5px'
                  }}
                  required
                  onChange={(e) => setOffice(e.target.value)}
                >
                  <MenuItem value={'CAIRO'}>Cairo</MenuItem>
                  <MenuItem value={'ALEXANDRIA'}>Alexandria</MenuItem>
                  <MenuItem value={'UAE'}>UAE</MenuItem>
                  <MenuItem value={'KSA'}>KSA</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Divider>
            <Chip label="Beneficiaries" />
          </Divider>
          {/* Render Beneficiaries */}
          {beneficiaries.map((ben) => {
            return (
              <Grid direction="column" container key={ben.id} mt={{ xs: 2 }}>
                <Grid item container>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <TextField
                        label="Name"
                        required
                        variant="outlined"
                        type="text"
                        value={beneficiaries.find((x) => x.id === ben.id).name}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                          const newBeneficiaries = beneficiaries.slice();
                          const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                          newBeneficiaries[idx].name = e.target.value;
                          setBeneficiaries([...newBeneficiaries]);
                        }}
                      />
                    </Grid>
                    <Grid item md={2} xs={0}></Grid>
                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel id="gender-ben-label">Gender </InputLabel>
                        <Select
                          labelId="gender-ben-label"
                          id="gender-ben"
                          label="Gender"
                          variant="outlined"
                          value={beneficiaries.find((x) => x.id === ben.id).gender}
                          onChange={(e) => {
                            const newBeneficiaries = beneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].gender = e.target.value;
                            setBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'MALE'}>Male</MenuItem>
                          <MenuItem value={'FEMALE'}>Female</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid item container md={2} xs={0}></Grid>
                  <Grid item container md={5} xs={12}>
                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel id="relationship-ben-label">Relationship </InputLabel>
                        <Select
                          labelId="relationship-ben-label"
                          id="relationship-ben"
                          label="Relationship"
                          value={beneficiaries.find((x) => x.id === ben.id).relationship}
                          onChange={(e) => {
                            const newBeneficiaries = beneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].relationship = e.target.value;
                            setBeneficiaries([...newBeneficiaries]);
                          }}
                        >
                          <MenuItem value={'SPOUSE'}>Spouse</MenuItem>
                          <MenuItem value={'CHILD'}>Child</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={0}></Grid>
                    <Grid item md={5} xs={12} mt={{ xs: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          renderInput={(props) => (
                            <TextField {...props} style={{ width: '100%' }} />
                          )}
                          label="Birthdate"
                          value={beneficiaries.find((x) => x.id === ben.id).birthdate}
                          onChange={(newValue) => {
                            const newBeneficiaries = beneficiaries.slice();
                            const idx = newBeneficiaries.findIndex((x) => x.id === ben.id);
                            newBeneficiaries[idx].birthdate = dayjs(newValue);
                            setBeneficiaries([...newBeneficiaries]);
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>

                <Button
                  variant="outlined"
                  style={{ marginLeft: 'auto', marginRight: '0', marginBottom: '16px' }}
                  onClick={() => {
                    const newBeneficiaries = [...beneficiaries].filter((x) => x.id !== ben.id);
                    setBeneficiaries([...newBeneficiaries]);
                  }}
                  color="error"
                >
                  Delete Beneficiary
                </Button>
                <Grid mb={2}>
                  <Divider />
                </Grid>
              </Grid>
            );
          })}
          <Button
            variant="outlined"
            style={{ marginLeft: 'auto', marginRight: '0', marginTop: '10px' }}
            onClick={handleAddBeneficiaries}
          >
            Add Beneficiary
          </Button>

          <Grid mt={3}>
            <Button variant="contained" type="submit" style={{ width: '100%' }}>
              Create Employee
            </Button>
          </Grid>
        </Stack>
      </form>
    </Page>
  );
};
export default NewEmployee;
